<template>
  <component
    v-bind="$attrs"
    :is="tag"
    class="button"
    :class="[
      {
        disabled,
        loading,
        text,
        plain,
        dark,
      },
      size,
      color,
    ]"
  >
    <div v-if="loading">
      <slot name="loader">
        <svgo-loader class="button__loader" />
      </slot>
    </div>
    <div v-else class="button__inner">
      <slot name="prepend-icon">
        <component
          :is="prependIconComponent"
          v-if="prependIconComponent"
          class="prepend-icon"
        />
      </slot>
      <slot />
      <slot name="append-icon">
        <component
          :is="appendIconComponent"
          v-if="appendIconComponent"
          class="append-icon"
        />
      </slot>
    </div>
  </component>
</template>

<script setup>
import { computed, resolveComponent } from 'vue';

const props = defineProps({
  loading: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  text: { type: Boolean, default: false },
  plain: { type: Boolean, default: false },
  dark: { type: Boolean, default: false },
  prependIcon: { type: String, default: '' },
  appendIcon: { type: String, default: '' },
  tag: {
    type: String,
    default: 'button',
    validator(value) {
      return ['button', 'router-link', 'a', 'div'].includes(value);
    },
  },
  size: {
    type: String,
    default: null,
    validator(value) {
      return ['small'].includes(value);
    },
  },
  color: {
    type: String,
    default: 'primary',
    validator(value) {
      return ['primary', 'secondary', 'accent'].includes(value);
    },
  },
});

const prependIconComponent = computed(() =>
  props.prependIcon ? resolveComponent(`svgo-${props.prependIcon}`) : null,
);
const appendIconComponent = computed(() =>
  props.appendIcon ? resolveComponent(`svgo-${props.appendIcon}`) : null,
);
</script>

<style lang="scss">
@use '@styles/components/ui/button.scss' as *;
</style>
